export default {
  showFavourites: true,
  general: {
    useSidebarSubnavigation: true,
    showHomeButton: true,
    showProductCountWidget: true,
    showSensorealBranding: false,
  },

  filter: {
    enabled: true,
    propertyType: false,
    propertyStatus: false,
    propertyPriceRange: true,
    dwellingDisplayName: true,
  },

  labels: {
    details: {
      en: 'Details',
      ar: 'التفاصيل'
    },
    dwellingLabel: { en: 'Design' },
    dwellingBuilder: { en: 'Builder' },
    dwellingDesign: { en: 'Design' },
    dwellingSize: { en: 'Living Area' },
    dwellingFeatures: { en: 'Features' },
    dwellingDescription: { en: 'description' },
    dwellingPrice: { en: 'Price' },
    dwellingBeds: { en: 'Beds' },
    dwellingBaths: { en: 'Baths' },
    dwellingCars: { en: 'Cars' },
    propertyLabel: { en: 'Unit Number' },
    propertySize: { en: 'Land Area' },
    propertyPrice: { en: 'Price' },
    frontage: { en: 'Frontage' },
    depth: { en: 'Depth' },
    description: {
      en: 'Description',
      ar: 'وصف',
    },
    exploreCommunities: {
      en: 'Explore Communities',
      ar: 'استكشاف المجتمعات'
    },
    features: {
      en: 'Features',
      ar: 'المواصفات​',
    },
    openingHours: {
      en: 'Opening Hours',
      ar: 'ساعات العمل',
    },
    backButton: {
      en: 'Back',
    },
    favouritesButton: {
      en: 'Favourites',
      ar: 'عرض المفضلة'
    },
    addToFavourites: {
      en: 'Add to Favourites',
      ar: 'أضف إلى المفضلة'
    },
    available: {
      "en": "Available",
      "ar": "متاح"
    },
    onHold: {
      "en": "On Hold",
      "ar": "لم يطلق"
    },
    sold: {
      "en": "Sold",
      "ar": "مباع"
    },
    viewLabel: {
      "en": "Aspect",
    }
  },
}
